import { Afspraak, HouseReason, Klant, Reason } from '@ha/domain';

export class AfspraakBuilder {
    private klant: Klant;
    private reason: Reason;
    private houseReason?: HouseReason;
    private refinance?: boolean;
    private extraInfo?: string;
    private googleClickId?: string;

    withKlant(klant: Klant) {
        this.klant = klant;
        return this;
    }

    withReason(reason: Reason) {
        this.reason = reason;
        return this;
    }

    withHouseReason(houseReason: HouseReason) {
        this.houseReason = houseReason;
        return this;
    }

    withRefinance(refinance: boolean) {
        this.refinance = refinance;
        return this;
    }

    withExtraInfo(extraInfo: string) {
        this.extraInfo = extraInfo;
        return this;
    }

    withGoogleClickId(googleClickId: string) {
        this.googleClickId = googleClickId;
        return this;
    }

    build(): Afspraak {
        return {
            klant: this.klant,
            reason: this.reason,
            house_reason: this.houseReason,
            refinance: this.refinance,
            extra_info: this.extraInfo,
            google_click_id: this.googleClickId
        } as Afspraak;
    }
}
